/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_BG_BG: Record<string, string> = {
    ariaAnnounceChart: 'диаграма, ${seriesCount}[number] серии',
    ariaAnnounceFlowProportionLink: 'връзка ${index} от ${count}, от ${from} до ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'възел ${index} от ${count}, ${description}',
    ariaAnnounceGaugeChart: 'графика тип манометър, ${caption}',
    ariaAnnounceHierarchyChart: 'йерархична диаграма, ${caption}',
    ariaAnnounceHierarchyDatum: 'ниво ${level}[number], ${count}[number] деца, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Натиснете Space или Enter, за да превключите видимостта',
    ariaLabelAddHorizontalLine: 'Добавяне на хоризонтална линия',
    ariaLabelAnnotationOptionsToolbar: 'Опции за анотация',
    ariaLabelAnnotationSettingsDialog: 'Настройки на анотации',
    ariaLabelColorPicker: 'Цветова палитра',
    ariaLabelFinancialCharts: 'Финансови диаграми',
    ariaLabelLegend: 'Легенда',
    ariaLabelLegendItem: '${label}, Елемент на легендата ${index}[number] от ${count}[number]',
    ariaLabelLegendItemUnknown: 'Неизвестен елемент в легендата',
    ariaLabelLegendPageNext: 'Следваща страница на легендата',
    ariaLabelLegendPagePrevious: 'Предишна страница на легендата',
    ariaLabelLegendPagination: 'Пагинация на легендата',
    ariaLabelNavigator: 'Навигатор',
    ariaLabelNavigatorMaximum: 'Максимум',
    ariaLabelNavigatorMinimum: 'Минимум',
    ariaLabelNavigatorRange: 'Обхват',
    ariaLabelRangesToolbar: 'Обхвати',
    ariaLabelSettingsTabBar: 'Настройки',
    ariaLabelZoomToolbar: 'Мащабиране',
    ariaValuePanRange: '${min}[percent0to2dp] до ${max}[percent0to2dp]',
    contextMenuDownload: 'Изтегляне',
    contextMenuPanToCursor: 'Премести тук',
    contextMenuToggleOtherSeries: 'Превключване на други серии',
    contextMenuToggleSeriesVisibility: 'Превключване на видимостта',
    contextMenuZoomToCursor: 'Увеличи до тук',
    dialogHeaderChannel: 'Канал',
    dialogHeaderDatePriceRange: 'Дата и Цена',
    dialogHeaderDateRange: 'Период на дати',
    dialogHeaderFibonacciRange: 'Фиб ретрейсмент',
    dialogHeaderLine: 'Линия',
    dialogHeaderPriceRange: 'Диапазон на цените',
    dialogHeaderText: 'Текст',
    dialogInputAlign: 'Подравняване',
    dialogInputColorPicker: 'Цвят',
    dialogInputColorPickerAltText: 'Цвят на текста',
    dialogInputExtendAbove: 'Разшири нагоре',
    dialogInputExtendBelow: 'Разшири отдолу',
    dialogInputExtendChannelEnd: 'Удължете края на канала',
    dialogInputExtendChannelStart: 'Разширяване на началото на канала',
    dialogInputExtendLeft: 'Удължи наляво',
    dialogInputExtendLineEnd: 'Удължаване на края на линията',
    dialogInputExtendLineStart: 'Удължаване на началото на линията',
    dialogInputExtendRight: 'Разгъни надясно',
    dialogInputFibonacciBands: 'Ленти',
    dialogInputFibonacciBandsAltText: 'Фибоначи ленти',
    dialogInputFillColorPicker: 'Запълване',
    dialogInputFillColorPickerAltText: 'Цвят на запълване',
    dialogInputFontSize: 'Размер',
    dialogInputFontSizeAltText: 'Размер на шрифта',
    dialogInputLineStyle: 'Тире',
    dialogInputPosition: 'Позиция',
    dialogInputReverse: 'Обръщане',
    dialogInputShowFill: 'Показване на запълване',
    dialogInputStrokeWidth: 'Тегло',
    dialogInputStrokeWidthAltText: 'Ширина на линията',
    iconAltTextAlignCenter: 'Център',
    iconAltTextAlignLeft: 'Ляво',
    iconAltTextAlignRight: 'Дясно',
    iconAltTextClose: 'Затвори',
    iconAltTextLineStyleDashed: 'Дълга пунктирана линия',
    iconAltTextLineStyleDotted: 'С къси тирета',
    iconAltTextLineStyleSolid: 'Плътна',
    iconAltTextPositionBottom: 'Долу',
    iconAltTextPositionCenter: 'Център',
    iconAltTextPositionTop: 'Горе',
    inputTextareaPlaceholder: 'Добави текст',
    measurerDateRangeBars: '${value}[number] ленти',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: "„${value}[number]'",
    measurerVolume: 'Обем ${value}',
    overlayLoadingData: 'Зареждане на данни...',
    overlayNoData: 'Няма данни за показване',
    overlayNoVisibleSeries: 'Няма видима серия',
    overlayUnsupportedBrowser: 'Несъвместима версия на браузъра. Моля, актуализирайте своя браузър.',
    seriesHistogramTooltipCount: '${yName} (брой)',
    seriesHistogramTooltipFrequency: 'Честота',
    seriesHistogramTooltipMean: '${yName} (средно)',
    seriesHistogramTooltipSum: '${yName} (сума)',
    toolbarAnnotationsArrow: 'Стрела',
    toolbarAnnotationsArrowDown: 'Стрелка надолу',
    toolbarAnnotationsArrowUp: 'Стрелка нагоре',
    toolbarAnnotationsCallout: 'Анотация',
    toolbarAnnotationsClearAll: 'Изчисти всичко',
    toolbarAnnotationsComment: 'Коментар',
    toolbarAnnotationsDatePriceRange: 'Дата и Цена',
    toolbarAnnotationsDateRange: 'Дата диапазон',
    toolbarAnnotationsDelete: 'Изтрий',
    toolbarAnnotationsDisjointChannel: 'Несвързан канал',
    toolbarAnnotationsDragHandle: 'Плъзнете лентата с инструменти',
    toolbarAnnotationsFibonacciAnnotations: 'Фибоначи',
    toolbarAnnotationsFibonacciRetracement: 'Фиб Отклонение',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Фиб трендово базирано',
    toolbarAnnotationsFillColor: 'Цвят на запълване',
    toolbarAnnotationsHorizontalLine: 'Хоризонтална линия',
    toolbarAnnotationsLineAnnotations: 'Тенденции',
    toolbarAnnotationsLineColor: 'Цвят на линията',
    toolbarAnnotationsLineStrokeWidth: 'Ширина на линията',
    toolbarAnnotationsLineStyle: 'Стил на линията',
    toolbarAnnotationsLock: 'Заключване',
    toolbarAnnotationsMeasurerAnnotations: 'Измерватели',
    toolbarAnnotationsNote: 'Забележка',
    toolbarAnnotationsParallelChannel: 'Паралелен канал',
    toolbarAnnotationsPriceRange: 'Ценови диапазон',
    toolbarAnnotationsQuickDatePriceRange: 'Измерване',
    toolbarAnnotationsSettings: 'Настройки',
    toolbarAnnotationsShapeAnnotations: 'Стрели',
    toolbarAnnotationsText: 'Текст',
    toolbarAnnotationsTextAnnotations: 'Текстови анотации',
    toolbarAnnotationsTextColor: 'Цвят на текста',
    toolbarAnnotationsTextSize: 'Размер на текста',
    toolbarAnnotationsTrendLine: 'Тренд линия',
    toolbarAnnotationsUnlock: 'Отключи',
    toolbarAnnotationsVerticalLine: 'Вертикална линия',
    toolbarRange1Month: '1М',
    toolbarRange1MonthAria: '1 месец',
    toolbarRange1Year: '1Г',
    toolbarRange1YearAria: '1 година',
    toolbarRange3Months: '3 мес.',
    toolbarRange3MonthsAria: '3 месеца',
    toolbarRange6Months: '6М',
    toolbarRange6MonthsAria: '6 месеца',
    toolbarRangeAll: 'Всички',
    toolbarRangeAllAria: 'Всички',
    toolbarRangeYearToDate: 'От началото на годината',
    toolbarRangeYearToDateAria: 'Годината до днешна дата',
    toolbarSeriesTypeCandles: 'Свещи',
    toolbarSeriesTypeDropdown: 'Тип диаграма',
    toolbarSeriesTypeHighLow: 'Високо Ниско',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Празни Свещи',
    toolbarSeriesTypeLine: 'Линия',
    toolbarSeriesTypeLineWithMarkers: 'Линия с маркери',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Стъпково очертаване',
    toolbarZoomPanEnd: 'Преместване до края',
    toolbarZoomPanLeft: 'Преместване наляво',
    toolbarZoomPanRight: 'Преместване надясно',
    toolbarZoomPanStart: 'Придвижване до началото',
    toolbarZoomReset: 'Нулиране на увеличението',
    toolbarZoomZoomIn: 'Приближаване',
    toolbarZoomZoomOut: 'Намаляване на мащаба',
    tooltipPaginationStatus: '${index}[number] от ${count}[number]',
};
